import axios from "axios";

export const fetchPerfiles = async (API_URL, setPerfiles) => {
  try {
    const response = await axios.get(`${API_URL}/api/perfiles`, {
      withCredentials: true,
    });
    setPerfiles(response.data); // Guardar perfiles en el estado
  } catch (error) {
    console.error("Error al obtener perfiles:", error);
  }
};

export const fetchCompanies = async (API_URL, setCompanies) => {
  try {
    const response = await axios.get(`${API_URL}/api/empresas`, {
      withCredentials: true,
    });
    setCompanies(response.data); // Guardar empresas en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchWorksType = async (API_URL, setTypeWorks) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-trabajos`, {
      withCredentials: true,
    });
    setTypeWorks(response.data); // Guardar tipo de trabajos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchLanguage = async (API_URL, setLanguage) => {
  try {
    const response = await axios.get(`${API_URL}/api/lenguajes`, {
      withCredentials: true,
    });
    setLanguage(response.data); // Guardar idioma en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchPermissions = async (API_URL, setPermissions) => {
  try {
    const response = await axios.get(`${API_URL}/api/obtener-permisos`, {
      withCredentials: true,
    });
    setPermissions(response.data); // Guardar permisos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchProjects = async (API_URL, setProjects) => {
  try {
    const response = await axios.get(`${API_URL}/api/proyectos`, {
      withCredentials: true,
    });
    setProjects(response.data); // Guardar permisos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchClients = async (API_URL, setClients) => {
  try {
    const response = await axios.get(`${API_URL}/api/clientes`, {
      withCredentials: true,
    });
    setClients(response.data); // Guardar permisos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchPermitHolder = async (API_URL, setPermisionarios, value) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/permisionarios-cliente?clienteId=${value}`,
      {
        withCredentials: true,
      }
    );
    setPermisionarios(response.data); // Guardar permisos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const createUser = async (API_URL, usuarioPayload, confirmacion) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/usuarios?confirmacion=${confirmacion}`,
      usuarioPayload,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al procesar usuario:", error);
    throw error;
  }
};

export const changeViewProvider = async (API_URL, views, id) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/usuarios-vistas-empresas?id=${id}`,
      views,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return response.status;
  } catch (error) {
    console.error("Error al procesar usuario:", error);
    throw error;
  }
};

export const changeViewProjects = async (API_URL, views, id) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/usuarios-vistas-proyectos?id=${id}`,
      views,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return response.status;
  } catch (error) {
    console.error("Error al procesar usuario:", error);
    throw error;
  }
};

export const fetchUserById = async (API_URL, id) => {
  try {
    const response = await axios.get(`${API_URL}/api/usuarios/${id}`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al procesar usuario:", error);
    throw error;
  }
};

export const fetchMapInstallers = async (API_URL, setInstallerMap) => {
  try {
    const response = await axios.get(`${API_URL}/api/mapas/instaladores`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
    const mappedMarkers = response.data.map((item) => ({
      lat: item.latitude,
      lng: item.longitude,
      icon: item.icon,
      nombre: `${item.nombre} ${item.apellidos}`,
      numGafete: item.numGafete,
      empresa: item.empresa.razonSocial,
      fecha: item.fecha,
    }));
    setInstallerMap(mappedMarkers);
  } catch (error) {
    console.error("Error al obtener los instaladores del mapa:", error);
    throw error;
  }
};

export const fetchStatusProviders = async (API_URL, setStatusProviders) => {
  try {
    const response = await axios.get(`${API_URL}/api/estatus-empresas`, {
      withCredentials: true,
    });
    setStatusProviders(response.data); // Guardar permisos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchStates = async (API_URL, setStates) => {
  try {
    const response = await axios.get(`${API_URL}/api/estados`, {
      withCredentials: true,
    });
    setStates(response.data); // Guardar permisos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchSpecialties = async (API_URL, setSpecialties) => {
  try {
    const response = await axios.get(`${API_URL}/api/especialidades`, {
      withCredentials: true,
    });
    setSpecialties(response.data); // Guardar permisos en el estado
  } catch (error) {
    console.error("Error al obtener empresas:", error);
  }
};

export const fetchInstallers = async (API_URL, empresaId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/contactos-instaladores?empresaId=${empresaId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener Instaladores:", error);
  }
};

export const fetchInstallersDisabled = async (API_URL, empresaId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/contactos-instaladores?empresaId=${empresaId}&buscarInhabilitados=true`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener Instaladores:", error);
  }
};

export const fetchProfileInstallers = async (API_URL, setProfileInstallers) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/buscar-perfil-instalador`,
      {
        withCredentials: true,
      }
    );
    setProfileInstallers(response.data); // Guardar Instaladores
  } catch (error) {
    console.error("Error al obtener Perfil Instaladores:", error);
  }
};

export const fetchProviderById = async (API_URL, id) => {
  try {
    const response = await axios.get(`${API_URL}/api/empresas/${id}`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al procesar empresa:", error);
    throw error;
  }
};

export const fetchInstallerById = async (API_URL, id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/contactos-instaladores/${id}`,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al procesar instalador:", error);
    throw error;
  }
};

export const fetchInstallerDocumentsType = async (API_URL) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/tipos-multimedia-contacto`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener tipo de documentos de Instaladores:",
      error
    );
  }
};

const tipoMultimediaMapping = {
  PHOTO: "FOTO",
  INE: "INE",
  IMSS: "IMSS",
  MEDICAL_CERTIFICATE: "CERTIFICADO_MEDICO",
  DC3: "DC3",
  CREDENTIAL: "CREDENCIAL",
  OTHER: "OTRO",
};

export const fetchInstallerImage = async (API_URL, lenguaje, id, extension) => {
  try {
    // Obtener el valor correcto de tipoMultimediaContacto
    const tipoMultimediaContacto = tipoMultimediaMapping[lenguaje];

    if (!tipoMultimediaContacto) {
      throw new Error(
        `No se encontró un tipo de multimedia válido para: ${lenguaje}`
      );
    }

    // Determinar la disposición de contenido en función de la extensión
    const disposicionContenido = extension === "pdf" ? "ATTACHMENT" : "INLINE";

    const response = await axios.get(
      `${API_URL}/api/descargar-imagen-contacto`,
      {
        params: {
          disposicionContenido,
          tipoMultimediaContacto,
          id,
        },
        responseType: "blob",
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    console.error(`Error cargando la imagen para ${lenguaje}:`, error);
    throw error;
  }
};

export const uploadInstallerMedia = async (
  API_URL,
  contactoId,
  tipoMultimedia,
  file
) => {
  try {
    const formData = new FormData();
    formData.append("contactoId", contactoId);
    formData.append("tipoMultimedia", tipoMultimedia);
    formData.append("tipoAplicacion", "WEB");
    formData.append("file", file);

    const response = await axios.post(
      `${API_URL}/api/subir-multimedia-contacto`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    return { status: response.status, success: response.status === 200 };
  } catch (error) {
    console.error("Error al subir la multimedia del contacto:", error);
    throw error;
  }
};

export const updateMediaExpiration = async (
  API_URL,
  contactoId,
  tipoMultimedia,
  fecha
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/contactos-instaladores/actualizar-vencimiento-multimedia-contacto-instalador`,
      { contactoId, tipoMultimedia, fecha },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error al actualizar vencimiento de multimedia:", error);
    throw error;
  }
};

export const fetchDocumentProvider = async (API_URL, id) => {
  try {
    // Asegurar que el ID está definido
    if (!id) {
      throw new Error("ID del documento no proporcionado.");
    }

    // Construir la URL completa para la descarga
    const downloadUrl = `${API_URL}/api/descargar-contrato-empresa`;

    const response = await axios.get(downloadUrl, {
      params: {
        disposicionContenido: "ATTACHMENT", // Descargar directamente
        id,
      },
      responseType: "blob", // Recibir datos binarios (PDF, imágenes)
      withCredentials: true, // Incluir credenciales de sesión
    });

    return response.data;
  } catch (error) {
    console.error(`❌ Error descargando el documento con ID ${id}:`, error);
    throw error;
  }
};

export const uploadCompanyContract = async (
  API_URL,
  empresaId,
  documento,
  fechaVencimiento,
  file,
  contactos = ""
) => {
  try {
    // Validar que todos los parámetros requeridos estén presentes
    if (!empresaId || !documento || !fechaVencimiento || !file) {
      throw new Error(
        "Faltan parámetros requeridos para la subida del contrato."
      );
    }

    // Formatear la fecha con zona horaria en español
    const fechaVencimientoFormatted = new Date(fechaVencimiento).toString();

    // Codificar la fecha para enviarla correctamente en la petición
    const fechaVencimientoEncoded = encodeURIComponent(
      fechaVencimientoFormatted
    );

    // Crear FormData para enviar el archivo
    const formData = new FormData();
    formData.append("file", file);

    // Hacer la petición POST a la API de subida de contratos
    const response = await axios.post(
      `${API_URL}/api/subir-contratos-empresa?empresaId=${empresaId}&documento=${documento}&fechaVencimiento=${fechaVencimientoEncoded}&contactos=${contactos}
      `,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    return response.data; // Retorna la respuesta del backend
  } catch (error) {
    console.error("❌ Error al subir el contrato de empresa:", error);
    throw error;
  }
};

export const deleteInstallerDocument = async (
  API_URL,
  contactoId,
  tipoMultimedia
) => {
  try {
    const response = await axios.delete(`${API_URL}/api/borra-documento`, {
      params: {
        contactoId,
        tipoMultimedia,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error al eliminar documento:", error);
    throw error;
  }
};

export const deleteCompanyFile = async (API_URL, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/contratos-empresa/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al eliminar documento:", error);
    throw error;
  }
};

export const updateUser = async (API_URL, userData) => {
  try {
    const response = await axios.put(`${API_URL}/api/usuarios`, userData, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error("❌ Error al actualizar usuario:", error);
    throw error;
  }
};

export const createProvider = async (API_URL, payload) => {
  try {
    const response = await axios.post(`${API_URL}/api/empresas`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProvider = async (API_URL, payload) => {
  try {
    const response = await axios.put(`${API_URL}/api/empresas`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProvider = async (API_URL, id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/empresas/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteInstallerContact = async (API_URL, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/contactos-instaladores/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createInstallerContact = async (API_URL, payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/contactos-instaladores`,
      payload,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInstallerContact = async (API_URL, payload) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/nxt/contactos-instaladores`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const confirmarDescargarExcel = async (
  API_URL,
  contrasenaOperacion,
  confirmDialog,
  retryCallback
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/confirmar-contrasena-operacion-a`,
      {
        contrasenaOperacion,
        razon: "DOWNLOAD_COMPANIES_EXCEL",
      },
      { withCredentials: true }
    );

    if (response.status === 200) {
      // Creamos y disparamos un form para que el navegador maneje la descarga
      const form = document.createElement("form");
      form.method = "POST";
      form.action = `${API_URL}/api/confirmar-contrasena-operacion-a`;
      form.style.display = "none";

      const contrasenaInput = document.createElement("input");
      contrasenaInput.name = "contrasenaOperacion";
      contrasenaInput.value = contrasenaOperacion;
      form.appendChild(contrasenaInput);

      const razonInput = document.createElement("input");
      razonInput.name = "razon";
      razonInput.value = "DOWNLOAD_COMPANIES_EXCEL";
      form.appendChild(razonInput);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }
  } catch (error) {
    const es401 = error.response?.status === 401;

    confirmDialog({
      html: es401
        ? "Contraseña incorrecta. Intenta de nuevo."
        : "Ocurrió un error al confirmar o descargar el archivo.",
      icon: "error",
      confirmButtonText: "Intentar de nuevo",
      mostrarCancelar: false,
      onConfirm: retryCallback,
    });
  }
};

// export const confirmarDescargarExcel = async (
//   API_URL,
//   contrasenaOperacion,
//   confirmDialog,
//   retryCallback
// ) => {
//   try {
//     const response = await axios.post(
//       `${API_URL}/api/confirmar-contrasena-operacion-a`,
//       {
//         contrasenaOperacion,
//         razon: "DOWNLOAD_COMPANIES_EXCEL",
//       },
//       { withCredentials: true }
//     );

//     if (response.status === 200) {
//       const excelResponse = await axios.get(`${API_URL}/api/empresas/excel`, {
//         responseType: "blob",
//         withCredentials: true,
//       });
//       FileSaver.saveAs(excelResponse.data, "Empresas.xlsx");

//       confirmDialog({
//         html: "La descarga fue realizada con éxito.",
//         icon: "success",
//         confirmButtonText: "Aceptar",
//         mostrarCancelar: false,
//       });
//     }
//   } catch (error) {
//     const es401 = error.response?.status === 401;

//     confirmDialog({
//       html: es401
//         ? "Contraseña incorrecta. Intenta de nuevo."
//         : "Ocurrió un error al confirmar o descargar el archivo.",
//       icon: "error",
//       confirmButtonText: "Intentar de nuevo",
//       mostrarCancelar: false,
//       onConfirm: retryCallback,
//     });
//   }
// };
